
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pizza/italiensk",
      function () {
        return require("private-next-pages/pizza/italiensk/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pizza/italiensk"])
      });
    }
  